import { render, staticRenderFns } from "./KonfigOp.vue?vue&type=template&id=f674c786&scoped=true&"
import script from "./KonfigOp.vue?vue&type=script&lang=js&"
export * from "./KonfigOp.vue?vue&type=script&lang=js&"
import style0 from "./KonfigOp.vue?vue&type=style&index=0&id=f674c786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f674c786",
  null
  
)

export default component.exports